var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayImg)?_c('img',{staticClass:"d-inline-block mr-3",attrs:{"width":"20","src":_vm.displayImg}}):_c('div',{class:("d-inline-block mr-3 " + _vm.styleClass),style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }